import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getData } from "../../../../Services/Services";
import {
  getJobTitle,
  hierarchylevelListURL,
} from "../../../../Services/EndPoints";

//Component to view user details
const UserViewForm = () => {
  // Get user data passed from previous route
  const location = useLocation();
  const { data } = location.state || {};
  const [regionlist, setregionlist] = useState([]);

  // Fetch all reference data on component mount
  useEffect(() => {
    (async () => {
      const response = await getData(getJobTitle);
      // if (Array.isArray(response)) {
      //   setjobtitle(response);
      // }

      const region_all = await getData(hierarchylevelListURL);
      if (Array.isArray(response)) {
        setregionlist(region_all);
      }
    })();
  }, []);

  // Get user's assigned regions based on region mappings
  const getUserRegions = () => {
    if (!regionlist.length || !data.user_region_map.length) return [];

    const userRegionIds = data.user_region_map.map(
      (mapping) => mapping.region_id
    );
    return regionlist.filter((region) => userRegionIds.includes(region.id));
  };

  const userRegions = getUserRegions();
  return (
    <>
      <div className="container-fluid p-0" style={{ overflow: "hidden" }}>
        <div
          className="row g-0"
          style={{ minHeight: "75vh", overflow: "hidden" }}
        >
          {/* Left Panel */}
          <div className="col-md-12 p-4 bg-white">
            <div className="grid-4-col">
              <div className="field">
                <span className="label"> First Name</span>
                <span className="value">{data?.first_name || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">Last Name</span>
                <span className="value">{data?.last_name || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">Role</span>
                <span
                  className="value"
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    display: "block",
                    width: "100%",
                  }}
                >
                  {data?.user_role_map_forSearch || "NA"}
                </span>
              </div>
              <div className="field">
                <span className="label">Phone Numer One</span>
                <span className="value">{data?.phone_number || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">Phone Numer Two</span>
                <span className="value">
                  {data?.secondary_phone_number || "NA"}
                </span>
              </div>
              <div className="field">
                <span className="label">User Name</span>
                <span className="value">{data?.user_name || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">Department</span>
                <span className="value">
                  {data?.user_department_map?.[0]?.departmentEntity?.name ||
                    "NA"}
                </span>
              </div>
              <div className="field">
                <span className="label">Job Title</span>
                <span className="value"> {data?.jobTitleName || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">User Level</span>
                <span className="value">{data?.userLevel || "NA"}</span>
              </div>
              {/* New Bank Name Field */}
              <div className="field">
                <span className="label">Bank Name</span>
                <span className="value">{data?.bankName || "NA"}</span>
              </div>
              {/* New Branch Name Field */}
              <div className="field">
                <span className="label">Branch Name</span>
                <span className="value">{data?.branchName || "NA"}</span>
              </div>
              <div className="field">
                <span className="label">Regions</span>
                <span
                  className="value"
                  style={{
                    marginBottom: "15px",
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    display: "block",
                    width: "360%",
                  }}
                >
                  {userRegions.length > 0
                    ? userRegions.map((region) => region.name).join(", ") ||
                      "NA"
                    : "NA"}
                </span>
              </div>
            </div>
            <div className="field">
              <span className="label">Address</span>
              <span
                className="value"
                style={{
                  marginBottom: "15px",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  display: "block",
                  width: "300%",
                }}
              >
                {data?.address || "NA"}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UserViewForm;
